import "./Navbar.css";
import logo2 from "../assets/logo2.png";
import { useAuthContext } from "../hooks/useAuthContext";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Collapse from "bootstrap/js/dist/collapse";

export default function Navbar({ profile }) {
  const { user, dispatch } = useAuthContext();
  const navi = useNavigate();

  const closeNav = () => {
    const el = document.getElementById("lpNavCollapse");
    if (!el) return;

    const instance =
      Collapse.getInstance(el) || new Collapse(el, { toggle: false });
    instance.hide();
  };

  if(profile){


  return (
    <div className="lp-nav">
      <nav className="lp-wrap navbar navbar-expand-lg">
        <Link
          className="navbar-brand d-flex align-items-center gap-2 text-decoration-none"
          to="/"
        >
          <img
            src={logo2}
            alt="ADHD and Neurodiversity Counsellors Online"
            className="neuro-logo"
          />

          <div className="neuro-brand-text">
            <div className="neuro-subtitle">Neuro Therapy Directory</div>
            <div className="neuro-title">ADHD &amp; Neurodiversity</div>
            <div className="neuro-subtitle">
              <strong>Online</strong> Therapy
            </div>
          </div>
        </Link>

        {user ? (
          <>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#lpNavCollapse"
              aria-controls="lpNavCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>

            <div
              className="collapse navbar-collapse justify-content-end"
              id="lpNavCollapse"
            >
          
          
              <div className="navbar-nav align-items-lg-center gap-2">
      {profile.complete &&      <>
                <NavLink className="lp-link nav-link" to="/" onClick={closeNav}>
                  Home
                </NavLink>

                <NavLink
                  className="lp-link nav-link"
                  to="/Availability"
                  onClick={closeNav}
                >
                  Availability
                </NavLink>

                <NavLink
                  className="lp-link nav-link"
                  to="/Enquiries"
                  onClick={closeNav}
                >
                  Enquiries
                </NavLink>

                <NavLink
                  className="lp-link nav-link"
                  to="/profile"
                  onClick={closeNav}
                >
                  Profile
                </NavLink>

                <NavLink
                  className="lp-link nav-link"
                  to="/myaccount"
                  onClick={closeNav}
                >
                  Settings
                </NavLink>
</>}
                <button
                  className="lp-btn lp-btn-ghost"
                  onClick={() => {
                    navi("/");
                    closeNav();
                    dispatch({ type: "LOGOUT" });
                  }}
                  type="button"
                >
                  Logout
                </button>
              </div>
            </div>
          </>
        ) : (
          <div className="ms-auto">
            <NavLink className="lp-btn lp-btn-ghost mt-3" to="/join">
              Join as a Therapist
            </NavLink>
          </div>
        )}
      </nav>
    </div>
  );
}
}